import Vue from 'vue'
import VueRouter from 'vue-router'
import routesList from './routers.js'
import store from '@/store'
Vue.use(VueRouter)

const routes = routesList
// [
//   {
//     path: '/',
//     name: 'home',
//     component: HomeView
//   },
//   // {
//   //   path: '/about',
//   //   name: 'about',
//   //   // route level code-splitting
//   //   // this generates a separate chunk (about.[hash].js) for this route
//   //   // which is lazy-loaded when the route is visited.
//   //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
//   // }
// ]
const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL,
  routes
})
const router = createRouter()
router.beforeEach((to, from, next) => {
  console.log(to, from)

  next()
})
router.afterEach((to, from) => {
  resetRouter()
  store.commit('log/setMonitoring', {
    title: "切换页面",
    formPage: from.path,
    toPage: to.path,
  })
})
export function resetRouter() {
  const newRouter = createRouter()
  var routerL = []
  for (var i = 0; i < newRouter.options.routes.length; i++) {//循环权限
    if (newRouter.options.routes[i].role) {

    } else {
      routerL.push(newRouter.options.routes[i])
    }

  }
  router.options.routes = routerL
  console.log(newRouter)
  router.matcher = newRouter.matcher // reset router
}
export default router
